import { combineReducers } from 'redux';

import selectionLetters from './selectionletters/reducer';

export default combineReducers({
  selectionLetters,
});



// WEBPACK FOOTER //
// ./src/pages/selectionletters/state/reducer.js